/**
 * @module experience/byod/byod-landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const BYOD_VALIDATION_CONSTANTS = {
  MODULE: 'BYOD',
  ASCENDING: 'ascending',
  DESCENDING: 'descending',
  RELEVANCE: 'relevance',
  IMEI: 'imei',
  CARRIERMAKEMODEL: 'carrierMakeModel',
  COLON: ':',
  SPACE: ' ',
  HANDSET: 'HANDSET',
  LEGAL_TEXT: 'legal-text',
  PHONE_SIM: 'phoneSim',
  TABLET_SIM: 'tabletSim',
  FULLY_COMPATIBLE: 'FULLY COMPATIBLE',
  PARTIALLY_COMPATIBLE: 'PARTIALLY COMPATIBLE',
  NOT_COMPATIBLE: 'NOT COMPATIBLE',
  SIMS: 'SIMS',
  SIM: 'Sim',
  TABLET: 'TABLET',
  HAVESIM: 'haveSim',
  NEEDSIM: 'needSim',
  AVAILABLE: 'AVAILABLE',
  UNAVAILABLE: 'UNAVAILABLE',
  ACTIVATION: 'ACTIVATION',
  FULL_RETAIL_PRICE: 'FRP',
  NO_ERROR_MESSAGE: 'No Error message for failure',
  INUSE: 'INUSE',
  POSTPAID: 'POSTPAID',
  SKIP: 'Skip',
  TRUE: 'TRUE',
  FALSE: 'FALSE',
  RETAIL: 'retail',
  WEB: 'web',
  BLOCKED: 'BLOCKED',
  AGING: 'AGING',
  RESERVED: 'RESERVED',
  FULL_COMP: 'FULLYCOMPATIBLE',
  PART_COMP: 'PARTIALLYCOMPATIBLE',
  NOT_COMP: 'NOTCOMPATIBLE',
  UNKNOWN: 'UNKNOWN',
  SIM_ESIM: 'sim-esim-number',
  RELEASED_ACTIVE: 'released_active',
  INSTALLED_ACTIVE: 'installed_active',
  EXPECTED_EID_LENGTH: '32',
  SIM_MIN_LENGTH: '19',
  ESIM: 'ESIM',
  PSIM: 'PSIM',
  LINE_1: 'L001',
  GBA: 'GBA',
  TMO_SIM_INPUT_LENGTH: '19',
  VOICE_DEVICE_FULLY_COMPATIBLE: 'VoiceDeviceFullyCompatible',
  VOICE_DEVICE_PARTIALLY_COMPATIBLE: 'VoiceDevicePartiallyCompatible',
  DATA_DEVICE_FULLY_COMPATIBLE: 'DataDeviceFullyCompatible',
  DATA_ONLY_PARTIALLY_COMPATIBLE: 'DataOnlyPartiallyCompatible',
  PESIM: 'PESIM',
  EID_WITH_F: 'F',
  HAVE_EID_LENGTH: '32',
  HAVE_ESIM_LENGTH: '19',
};

export const CARRIER_MAKE_CONSTANTS = {
  CARRIERMAKEMODEL_QUERYSTRING: {
    include: 'carrier,make,model',
    pagesize: '500',
    pagenumber: '1',
  },
};

export const BYOD_MODULE_COMPONENTS = {
  BYOD_MODULE_NAME: 'ByodModule',
  BYOD_LANDING_COMPONENT: 'ByodLandingComponent',
  SIM_VALIDATION_COMPONENT: 'SimValidationComponent',
  DEVICE_VALIDATION_COMPONENT: 'DeviceValidationComponent',
};

export const BYOD_AUDIT_CONSTANTS = {
  AUDIT_SIM_NUMBER: 'SIM_NUMBER',
  AUDIT_SIMKIT_NUMBER: 'SIMKIT_SIM_NUMBER',
  AUDIT_SIMKIT: 'SIMKIT',
};

export const BYOD_LANDING_CONSTANTS = {
  PRODUCT_SELECTOR: 'product-selector/setup',
  BYOD_LANDING_MODULE: 'byod landing module',
  MIXED_CART_ERROR: 'BIZ_0001_INVALID_TRANS_TYPE',
  CONTINUE: 'continue',
  VIEW_CART: 'viewcart',
  CART_URL: '/cart',
  ADD: 'add',
};

export const BYOD_PDL_COMPONENTS = {
  TOOL: 'tool',
  CLICK: 'click',
  CLICKTOACTION: 'clickToAction',
  CHECKCOMPATIBILITY: 'Check compatibility',
  IMEITOOLNAME: 'BYOD IMEI Checker',
  SIMTOOLNAME: 'BYOD SIM Card Checker',
  BUTTON: 'Button',
  START: 'start',
  COMPLETE: 'complete',
  SUBMIT: 'Submit',
  MODALLOAD: 'modal',
  LOAD: 'load',
};

export const BYOD_ESIM_CONSTANTS = {
  ESIM_SUPPORTED: 'Y',
  ESIM_NOT_SUPPORTED: 'N',
  ESIM_SUPPORT_UNKNOWN: 'UNKNOWN',
};

export const BYOD_SELECTED_SIM_RADIO_CONSTANTS = {
  SELECTPSIM: 'selectPsim',
  SELECTESIM: 'selectEsim',
  SELECTTMOSIM: 'selectTmoSim',
  ESIM: 'esim',
  PSIM: 'psim',
  TMOSIM: 'tmo-sim',
};
